import { router } from '@inertiajs/react'
import { Card, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

interface Props {
  note: {
    title: string
    slug: string
    directory: string
    tags: string[]
    excerpt: string
    updated_at: string
  }
}

export default function NoteCard({ note }: Props) {
  return (
    <Card
      className="cursor-pointer border-gray-200 bg-white transition-colors hover:border-gray-300"
      onClick={() => router.visit(`/notes/${note.slug}`)}
    >
      <CardContent className="pt-4">
        <div className="flex items-start justify-between">
          <h3 className="font-semibold text-gray-900">{note.title}</h3>
          <Badge variant="outline" className="ml-2 shrink-0 text-xs">{note.directory}</Badge>
        </div>
        {note.excerpt && (
          <p className="mt-1 text-sm text-gray-500 line-clamp-2">{note.excerpt}</p>
        )}
        <div className="mt-2 flex items-center gap-1.5">
          {note.tags.map(tag => (
            <Badge key={tag} variant="secondary" className="text-xs">{tag}</Badge>
          ))}
          <span className="ml-auto text-xs text-gray-400">
            {new Date(note.updated_at).toLocaleDateString()}
          </span>
        </div>
      </CardContent>
    </Card>
  )
}
